/**
 * Always use conditional dynamic imports for big libraries such as tiny-slider.
 * When choosing libraries, please consider their use of dependencies. Use vanilla JS libraries whenever possible.
 */

export const initCarouselSlider = () => {
    const carouselSliderInstance = document.querySelector('.js-carousel-slider');

    if (!carouselSliderInstance) {
        return;
    }

    import('tiny-slider/src/tiny-slider').then((root) => {
        root.tns({
            container: carouselSliderInstance,
            items: 3,
            loop: false,
            autoplayButtonOutput: false,
            responsive: {
                320: {
                    items: 1,
                },
                600: {
                    items: 2,
                },
                1024: {
                    items: 3,
                },
            },
        });
    });
};
